<template>
  <div class="container">
    <div class="container_top">
      <img class="container_top_img" src="../../assets/img/qiye2.png" alt="" />
      <span class="word1">{{ this.company.name }}</span>
    </div>
    <van-list
      class="listall"
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell class="listall-name" v-for="item in list" :key="item.id" @click="datail(item)">
        <!-- <div class="listtop">
          <div class="listtop-iamge">
            <van-image :src="require('../../assets/img/squkey.png')" />
          </div>
          <div class="listtop-content">ukey申请列表</div>
         
        </div> -->
        <div class="list-list-content">
          <span>法人key数量:&nbsp;{{item.legalNum}}</span>
        </div>
        <div class="list-list-content">代理人key数量:&nbsp;{{item.agentNum}}</div>
        <!-- <div class="list-list-content"><span>接受人:&nbsp;振勇</span></div> -->
        <div class="list-list-content">
          <span>公章key数量:&nbsp;{{item.sealNum}}</span>
        </div>
        <div class="list-list-content">
          <span v-if="item.isPass == 10">申请状态:&nbsp;<span  class="jk">待付款</span></span>
          <span v-if="item.isPass == 12">申请状态:&nbsp;<span  class="in">已支付</span></span>
          <span v-if="item.isPass == 20">申请状态:&nbsp;<span  class="jk">待审核</span></span>
          <span v-if="item.isPass == 21">申请状态:&nbsp;<span  class="bg">审核不通过</span></span>
          <span v-if="item.isPass == 22">申请状态:&nbsp;<span  class="in">审核通过</span></span>
          <span v-if="item.isPass == 99">申请状态:&nbsp;<span  class="in">已办key</span></span>
          <span v-if="item.isPass == 77">申请状态:&nbsp;<span  class="mr">已关闭</span></span>
          <span v-if="item.isPass == 88">申请状态:&nbsp;<span  class="mr">退款关闭</span></span>
        </div>
        <div class="list-list-content">
          <span>申请时间:&nbsp;{{item.createTime}}</span>
        </div>
        <div class="list-list-content" v-if="item.isPass == 21">
          <span>驳回原因:&nbsp;{{item.notPassRes}}</span>
        </div>
      </van-cell>
    </van-list>
    <van-button class="btn" @click.native="Application()">ukey申请</van-button>
  </div>
</template>

<script>
import {
  DropdownMenu,
  DropdownItem,
  Button,
  CellGroup,
  Cell,
  List,
  NavBar,
  Image,
} from "vant";
import api from "@/api";

export default {
  components: {
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Button.name]: Button,
    [CellGroup.name]: CellGroup,
    [Cell.name]: Cell,
    [List.name]: List,
    [NavBar.name]: NavBar,
    [Image.name]: Image,
  },
  data() {
    return {
      list: [],
      finished: false,
      loading: false,
      page: '0',
      limit: "10",
      company: "",
     
    };
  },
  created() {
    this.getBindingInfo();
    // this.getUkeyList();
  },
  methods: {
    /*ukey申请*/
    Application() {
      this.$router.push({
        name: "ukeyApplication",
      });
    },
    onLoad() {
      console.log('///')
      this.page = parseInt(this.page)
      this.page = this.page + 1
      this.getUkeyList()
    },
    datail(item){
      
      this.$router.push({
        name:'ukeyDtail',
        query:{
          id:item.id
        }
      })
    },
    getUkeyList() {
    const param = {
          page: String(this.page),
          limit:this.limit
      }
      api.ukey.getUkeyList(param).then((res) => {
        if (res.code === 0) {
          if(this.page === 1){
            this.list = res.data;
          }else{
            this.list = [...this.list, ...res.data]
          }
          this.loading = false
          if(this.list.length >= res.count){
            this.finished = true
          }
        //   this.list = res.data.map(item=>{
        //     if(item.isPass == 77){
        //       item.isPass = 3
        //     }
        //     return{
        //       ...item,
        //       classname:this.classname[item.isPass],
        //       liveStatusname:this.liveStatusname[item.isPass]
        //     }
        //   })
        }
      });
       
    },
    // 获取公司名称
    async getBindingInfo() {
      api.home.getBindingInfo().then((res) => {
        if (res.code == 0) {
          this.company = res.data;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  background-color: #f8f8f8;
  .container_top {
    height: 6.9333311vw;
    
    background-color: #f8f8f8;
    width: 100%;
    padding: 2.7666661vw 0 0 3.999999vw;
    display: flex;
    border-bottom: 1px solid #f8f8f8;
    .container_top_img {
      width: 4vw;
      height: 4vw;
      line-height: 4.2666656vw;
    }
    .word1 {
      width: 100%;
      height: 4.3999989vw;
      margin-left: 0.5999999vw;
      color: rgba(102, 102, 102, 1);
      font-size: 3.1999992vw;
      text-align: left;
    }
  }
  .listall {
    margin-top: 0.6rem;
    margin-right: 0.6rem;
    margin-left: 0.6rem;
    height: 82%;
    overflow: auto;
  }
  .listall-name {
    border-radius: 0.6rem;
    margin-bottom: 1rem;
    .listtop {
      display: flex;
      height: 2.6rem;
      align-items: center;
      border-bottom: 1px solid #eee;

      .listtop-iamge {
        .van-image {
          width: 4.5999986vw;
          height: 4.5999986vw;
          vertical-align: middle;
        }
      }
      .listtop-content {
        flex: 3;
        margin-left: 0.6rem;

        font-size: 4.5333322vw;
        white-space: nowrap;
        overflow: hidden;
        color: #222;
        text-overflow: ellipsis;
        font-weight: 600;
      }
    }
    .list-list-content {
      margin-top: 0.3rem;
      color: #666666;
      font-size: 3.7333324vw;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;

      .in {
        color: #45e215;
      }
      .bg{
        color: #C61B1B;
      }
      .jk{
        color: #FAA30C;
      }
      .mr{
        color: #999999;
      }
    }
  }
  .btn {
    // margin-bottom: 5vw;
    cursor: pointer;
    display: block;
    margin: auto;
    width: 90%;
    background: #1888f4;
    font-size: 4.5333322vw;
    color: #fff;
    border-radius: 2rem;
  }
}
</style>